<template>
  <CCard >      
    <CCardBody>       
      <CRow>      
        
        <CCol sm="12" lg="12" >                     
          <div style="border: 1px solid rgb(206, 210, 216);margin-top: 0px;padding-bottom: 5px;padding-top: 5px;border-bottom-width: 0px;">
            <div v-if="e_import==true" style="display: inline-block; padding: 10px; color: red;">❗</div>
            <div style="display: inline-block; padding: 10px;">主旨:</div>
            <div style="display: inline-block; width: 50%;"><ejs-textbox id="ProductName" floatLabelType="Auto"  placeholder="" v-model="e_title" disabled></ejs-textbox></div>   
 
            <div style="display: inline-block; padding: 10px;">發送者:</div>
            <div style="display: inline-block; width: 15%;"><ejs-textbox id="ProductName" floatLabelType="Auto"  placeholder="" v-model="e_CreateID" disabled></ejs-textbox></div> 
            <div style="display: inline-block; padding: 10px;">發送時間:</div>
            <div style="display: inline-block; width: 15%;"><ejs-textbox id="ProductName" floatLabelType="Auto"  placeholder="" v-model="e_CreateDate" disabled></ejs-textbox></div> 
          </div>           
        </CCol>        
        <CCol sm="12" lg="12"> 
          <!-- 使用 quill-editor 组件 -->        
          <div style="border: 1px solid rgb(206, 210, 216);margin-top: 0px;padding-bottom: 5px;padding-top: 5px;border-bottom-width: 1px; height: 700px;">      
              <div  
                type="text"
                id="view-container-wiki"
                readonly
                v-html="htmlContent"
                style="height: 100%; overflow-y: auto;">
              </div>              
          </div>
        </CCol>
      </CRow>
    </CCardBody>   
  </CCard>
</template>
<script>
// npm install vue-quill-editor --save


import Vue from "vue";
import { L10n, enableRipple  } from '@syncfusion/ej2-base';
import { TextBoxPlugin, NumericTextBoxPlugin  } from '@syncfusion/ej2-vue-inputs';  

import 'quill/dist/quill.snow.css';  // Quill 样式

import zhtwLocalization  from '../language/language.json';


L10n.load(zhtwLocalization);
enableRipple(true);
Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin );
export default {
name: 'EditorComponent',
components: {

},
data: function() {
  return {        
    e_import:false,
      e_title:"",
      e_CreateID:"",
      e_CreateDate:"",
      e_msgId:"",
      htmlContent: '<div><p><br></p><p>這是一個Html的測試</p><p>可以用Html Edit去編輯</p><h2>也可以放大喔</h2><p><strong>粗體也沒問題</strong></p><p><strong>加個網址吧 </strong><a href="https://google.com.tw" rel="noopener noreferrer" target="_blank"><strong>https://google.com.tw</strong></a></p><p>塞個小圖片<img src="data:image/jpeg;base64,/9j/2wCEAAIBAQEBAQIBAQECAgICAgQDAgICAgUEBAMEBgUGBgYFBgYGBwkIBgcJBwYGCAsICQoKCgoKBggLDAsKDAkKCgoBAgICAgICBQMDBQoHBgcKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCv/AABEIABcAMAMBIgACEQEDEQH/xAGiAAABBQEBAQEBAQAAAAAAAAAAAQIDBAUGBwgJCgsQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+gEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoLEQACAQIEBAMEBwUEBAABAncAAQIDEQQFITEGEkFRB2FxEyIygQgUQpGhscEJIzNS8BVictEKFiQ04SXxFxgZGiYnKCkqNTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqCg4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2dri4+Tl5ufo6ery8/T19vf4+fr/2gAMAwEAAhEDEQA/AP38rE+I3jey+HXgvUfGN7ZXN2LG1eWOys4vMmuXCkiKNR952xgDua2681/ai1RdD8BWusXUMj2sWrQpciPHyhz5YY56AFuT6V0YSlGtioQezZy46vLDYSdWO6X9fceL/FHV/FuveANP+L3x6+KOu+EtI8RajY2fh7SNI0ybzUa5uYntGuIsCS3kPEMqFiuGYHk1Uvrv4x/s4Pb/ABT8IfFE+LPBf2iS21gJIZksLhrstK08Y8yTcvzWsaxvsRigdVHzj0z9ryfwV4x+BVxaeL7pofCv2+we6a2vJInlRLiOROI13qA0aYxk8g4JUKee+GN/FefsWajrElk76fq2gatcT6U0SNePPMZ/MiYJkyP5pOG684PI40pZvi1mXsOROi1qmtFd2ilpq7KV2rtWXN8SvyYbI8PWrt1ZtS9zlkm7u/N7Ry1a09zlTSveVvhZ7t8NvHenfEvwRpvjbTLS5to9QtUla0vYGimt2KgmORGAKMM4Knkd63K8x/ZQvb3U/hm2oXe8h7xk3uc+Y8arHJID3DOpIPcGvTqzxdKNDEzpx2TOvBVpV8LCpLdr7/P57hWd4t8L6P418N3nhXX7UTWl9A0U8ZHUH+taNFYRlKMlJOzR0SjGcXGSumfPl3pvxu+A0kOj2yx61oyHZaambpFmiXPHmIxUtx1Knn0JyS3S7T42fH1PsUsS6FpUrbb+8e4jM5XPIRUZ855GSRjGQM4r0f4+/wDIuJ/vD+dRfs8f8i3J/vn/ANCNe4q0fqv1rkjz33t+Nr2v8j5v2E/r/wBS9pL2Vtrrbte17fP5nZeE/C+keC/Dtn4X0G2EVpZQLFCnsB1PvWjRRXhylKcnJu7Z9JGMYRUYqyR//9k="></p> </div>',  // 存储编辑器内容        
      selectedFormat: 'yyyy-MM-dd hh:mm a',      
      fields: { dataSource:  [
          { "id": 1, "name": "ALL", "hasChild": true, "expanded": true },
          { "id": 2, "pid": 1, "name": "Bryan" },
          { "id": 3, "pid": 1, "name": "Jimmy" },
          { "id": 4, "pid": 1, "name": "Frank" },
          { "id": 6, "pid": 1, "name": "Ryan" }
         
      ], value: 'id', text: 'name', parentValue: 'pid', hasChildren: 'hasChild' },
          height: '200px',
          waterMark: 'Select items',
          treeSettings: { autoCheck: true },
          customTemplate: '${value.length} item(s) selected'
    };
},
methods: {    
  //api
    getMsg: function () {  
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/Message/Msg?msgid=${this.e_msgId}`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.showMsg(response.data.msg) ;return; }                 
        this.e_title = response.data.datas.title;
        this.e_CreateID = response.data.datas.user;
        this.e_CreateDate = response.data.datas.date;
        this.htmlContent =response.data.datas.message;
        this.e_import =response.data.datas.import;
        console.log("GetUserMsg",response.data.datas)
        return; 
      })
      .catch((error) => { 
        this.showMsg(error) 
      })             
    },
    putRead: function () {  
          this.axios({
              method: 'put',
              baseURL: Vue.prototype.GLOBAL.baseURL,
              url: `/Message/My/Content?msgid=${this.e_msgId}`,
              headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          })
          .then((response) => {       
            if (!response.data.ok) { this.showMsg(response.data.msg) ;return; }                 
            this.datas = response.data.datas;
            // console.log(response.data.datas)
            return; 
          })
          .catch((error) => { 
            this.showMsg(error) 
          })             
        },
},
provide: {
},
created() {
    const msgID = this.$route.query.msgID;
    this.e_msgId =msgID;
    this.getMsg();
    this.putRead();
    

},
mounted() {
  
},
beforeUpdate() {
  
},
beforeDestroy() {
 
}  
}
</script>